<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.formation_line.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
        class="input-name"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="form-description mb-2"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="formation_line.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="formation_line"
        :content_rich_text="formation_line.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(formation_line, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="formation_line"
          :Text="formation_line.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.formation_line.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$getVisibleNames('mesh.faculty', true, 'Facultades') + ':'"
      label-for="input-faculties"
      label-cols="0"
      label-cols-sm="3"
      class="sm p-0 m-0"
    >
      <b-form-select
        id="input-faculties"
        v-model="$v.formation_line.faculties.$model"
        :options="facultiesList"
        value-field="id"
        text-field="name"
        :state="validateState('faculties')"
        aria-describedby="input-faculties-feedback"
        size="sm"
        multiple
        :select-size="facultiesList.length"
      ></b-form-select>
      <b-form-invalid-feedback id="input-faculties-feedback"
        >Debe agregar la
        {{ $getVisibleNames("mesh.faculty", false, "Facultades") }} de la
        {{
          $getVisibleNames("mesh.egressprofilematter", false, "Asignatura")
        }}.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.color')"
      label-for="input-color"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        type="color"
        id="input-color"
        name="input-color"
        v-model="$v.formation_line.color.$model"
        :state="validateState('color')"
        aria-describedby="input-color-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      >
      </b-form-input>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(this.formation_line.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="formation_line"></ModificationDate>
    </b-form-group>
    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.formation_line.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteFormationLine"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId, toast } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "FormationLineForm",
  mixins: [validationMixin],
  components: {
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    FormationLine: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          career: null,
          faculties: [],
          description: "",
          color: "#14acb4",
          updated_by: null,
          update_date: null,
          creation_date: null,
          created_by: null,
        };
      },
    },
    faculty_id: { default: null },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formation_line: { ...this.FormationLine },
    };
  },
  validations: {
    formation_line: {
      name: {
        required,
        minLength: minLength(5),
      },
      description: {},
      color: {},
      faculties: {
        isValid() {
          if (this.faculty_id != null) {
            if (this.formation_line.faculties.includes(this.faculty_id))
              return true;
            else return false;
          }
          return true;
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      careers: names.CAREERS,
      facultiesList: names.FACULTIES,
    }),
  },
  methods: {
    patchDescription(object, text) {
      this.formation_line.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.formation_line[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.formation_line.$touch();
      if (this.$v.formation_line.$anyError) {
        return;
      }
      if (isNaN(this.formation_line.id)) {
        this.createFormationLine();
      } else this.updateFormationLine();
    },
    createFormationLine() {
      this.$store
        .dispatch(names.POST_FORMATION_LINE, this.formation_line)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.formationline",
                false,
                "Línea De Formación"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateFormationLine() {
      this.$store
        .dispatch(names.UPDATE_FORMATION_LINE, this.formation_line)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.formationline",
                false,
                "Línea De Formación"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    deleteFormationLine() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.formationline",
            false,
            "Línea De Formación"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_FORMATION_LINE,
            this.formation_line.id
          );
          this.$emit("deleted", this.formation_line);
        }
      });
    },
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>

<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
.label {
  margin-top: 1%;
}
.input-name {
  margin-top: -1px;
}
#input-color {
  cursor: pointer;
}
</style>